import fetch from "auth/FetchInterceptor";

const SrdService = {};

SrdService.srdTableDatas = function (params) {
  return fetch({
    url:
      "/specimen-tracking/srd-table-data?start_date=" +
      params.startDate +
      "&end_date=" +
      params.endDate,
    method: "get",
  });
};

SrdService.drawHistoryForSrd = function (sampleId) {
  return fetch({
    url:
      "/specimen-tracking/phlebotomy-draw-history-for-srd?sample_id=" +
      sampleId,
    method: "get",
  });
};

SrdService.srdReceive = function (data) {
  return fetch({
    url: "/specimen-tracking/srd-receive",
    method: "post",
    data,
  });
};

SrdService.srdReject = function (data) {
  return fetch({
    url: "/specimen-tracking/srd-reject",
    method: "post",
    data,
  });
};

SrdService.srdRetain = function (data) {
  return fetch({
    url: "/specimen-tracking/srd-retain",
    method: "post",
    data,
  });
};

SrdService.srdDispose = function (data) {
  return fetch({
    url: "/specimen-tracking/srd-dispose",
    method: "post",
    data,
  });
};

SrdService.srdReport = function (data) {
  return fetch({
    url: "/specimen-tracking/srd-report",
    method: "post",
    data,
  });
};

SrdService.srdTubeTrackingReport = function(data){
  return fetch({
    url: "/specimen-tracking/srd-tube_tracking-report",
    method: "post",
    data,
  })
};

export default SrdService;
